import { useState, useContext } from 'react'
import { SnackbarContext } from 'contexts/SnackbarContext'
import {
  getMyReturns,
  getReturnById,
  sendMessage,
  Return,
  SendMessageParams
} from 'api/returns'
import { useTranslation } from 'react-i18next'

const useReturns = () => {
  const { t } = useTranslation()
  const [returns, setReturns] = useState<Return[]>([])
  const [isLoadingReturns, setIsLoadingReturns] = useState<boolean>(true)
  const { showMessage } = useContext(SnackbarContext)

  const fetchReturns = async () => {
    setIsLoadingReturns(true)
    const result = await getMyReturns()
    if (result.success && result.returns) {
      setReturns(result.returns)
    } else {
      showMessage(result.error || t('snackbar.returns.loadFailed'), 'error')
    }
    setIsLoadingReturns(false)
  }

  const fetchReturnById = async (returnId: string): Promise<Return | null> => {
    const result = await getReturnById(returnId)
    if (result.success && result.return) {
      return result.return
    } else {
      showMessage(result.error || t('snackbar.returns.detailsFailed'), 'error')
      return null
    }
  }

  const sendReturnMessage = async (
    returnId: string,
    params: SendMessageParams
  ): Promise<boolean> => {
    const result = await sendMessage(returnId, params)
    if (result.success) {
      return true
    } else {
      showMessage(result.error || t('snackbar.returns.sendFailed'), 'error')
      return false
    }
  }

  return {
    returns,
    fetchReturns,
    fetchReturnById,
    sendReturnMessage,
    isLoadingReturns
  }
}

export default useReturns
